import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';

import rootReducer from './reducers.js';
import { getEnvConfig } from '../utils/environment';
import { setIdByTitles } from '../utils/config';

// Create a history of your choosing (we're using a browser history in this case)
import createHistory from 'history/createBrowserHistory';
export const history = createHistory({ basename: '/analytics/ui'});

const config = getEnvConfig(true);

const defaultState = {
    reportCategories: setIdByTitles(config.categories)
};

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer,
    defaultState,
    composeEnhancers(
        applyMiddleware(middleware)
    )
);

export default store;


// WEBPACK FOOTER //
// ./src/core/store.js